import { html, css } from 'lit';
import { ifDefined } from 'lit/directives/if-defined';
import KaiElement from '../base';

class SeparatorElement extends KaiElement {
  static get is() {
    return 'kai-separator';
  }

  static get properties() {
    return {
      label: { type: String },
      collapsable: { type: Boolean },
      activated: { type: Boolean },
    };
  }

  static get styles() {
    return [
      super.styles,
      /* eslint-disable */
      css`
        .separator {
          width: 100%;
          height: 2.8rem;
          background-color: var(--separator-background-color, var(--color-gs00));
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 2rem;
          box-sizing: border-box;
        }

        .content {
          color: var(--theme-color-d);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          flex-grow: 1;
          margin: 0;
          text-align: left;
        }

        :-moz-dir(rtl) .content {
          text-align: right;
        }

        i {
          font-size: 2.4rem;
          margin-left: 1rem;
          margin-right: unset;
          color: var(--theme-color);
        }

        i:-moz-dir(rtl) {
          margin-left: unset;
          margin-right: 1rem;
        }

        i.activated {
          color: var(--color-gs20);
        }
      `,
      /* eslint-enable */
    ];
  }

  constructor() {
    super();
    this.collapsable = false;
    this.activated = false;
  }

  get icon() {
    return this.shadowRoot.querySelector('i');
  }

  _toggle() {
    this.activated = !this.activated;
    const event = new CustomEvent('toggle', {
      detail: { activated: this.activated },
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
  }

  render() {
    return html`
      <div
        class="separator"
        @click="${this.collapsable ? this._toggle : null}"
        role=${ifDefined(this.collapsable ? 'button' : undefined)}
        aria-expanded=${ifDefined(this.collapsable
                                    ? this.activated
                                    : undefined)}
      >
        <div class="h5 content" dir="auto">
          ${this.label}
        </div>
        ${this.collapsable
          ? html`
              <i
                class="${this.activated ? 'activated' : ''}"
                data-icon=${this.activated ? 'arrow-down' : 'arrow-up'}
              ></i>
            `
          : ''}
      </div>
    `;
  }
}

customElements.define(SeparatorElement.is, SeparatorElement);
